/**
 * @description Hook to get the active tab from the URL
 * @param {Array<{ id: string, voucher_campaign_name: string }>} voucherEmployees - The voucher employees to get the active tab from the URL
 * @param {string} TAB_PARAM - The parameter name to get the active tab from the URL
 * @param {string} defaultEmployeeId - The default employee id to use if no active tab is found in the URL
 * @param {function} handleTabChange - The function to handle the tab change
 * @returns {UseActiveTabReturn} - The active tab and the handleTabChange function
 * @returns {string} - The active tab
 */

import { useCallback } from "react";
import { useSearchParams } from "react-router";

const TAB_PARAM = "id";

export const useActiveTab = (voucherEmployees: Array<{ id: string, voucher_campaign_name: string }> = []) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeEmployeeId = searchParams.get(TAB_PARAM);

  const defaultEmployeeId = voucherEmployees.length > 0 ? voucherEmployees[0].id : null;
  const activeTab = activeEmployeeId || defaultEmployeeId || "All";

  const handleTabChange = useCallback((employeeId: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(TAB_PARAM, employeeId);
    setSearchParams(newSearchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return {
    activeTab,
    handleTabChange,
  };
};
